module.exports = __webpack_public_path__ + "img/11889364000190.4af0399f.png";